import { func, string, arrayOf, shape } from 'prop-types'
import React from 'react'

import styles from './MagazineIssueHighlights.module.scss'
import Grid from '../Grid'
import SmartLink from '../SmartLink'
import Type from '../Type'
import Container from '../Container'
import Title from '../Title'

const MagazineIssueHighlights = ({ highlights, onClick }) => {
  if (!highlights || !highlights.length) return null
  return (
    <div className={styles.MagazineIssueHighlights}>
      <Container
        gutter
        center
        size="wide"
        className={styles.MagazineIssueHighlightsWrapper}
      >
        <Title
          className={styles.Title}
          inverse
          title="Contents - Quick Look"
          bordered="desktop"
        />
        <Grid gutter="large" flex>
          {highlights.map((highlight, i) => (
            <Grid.Item
              width={{ t: 1 / 2, d: 1 / 2, dm: 1 / 4 }}
              key={`MagazineIssueH-${i}`}
              trailingGap="default"
            >
              <SmartLink
                className={styles.Highlight}
                onClick={() => onClick(highlight.pageNumber)}
              >
                <img loading="lazy" alt="highlight" src={highlight.imageUrl} />
                <div className={styles.HighlightContent}>
                  <div className={styles.HighlightTitle}>
                    <Type size="heading8" weight="medium">
                      {highlight.title}
                    </Type>
                  </div>
                  <div className={styles.Page}>
                    <Type size={['body2', 'body4']} weight="medium">
                      Page {highlight.pageNumber}
                    </Type>
                  </div>
                </div>
              </SmartLink>
            </Grid.Item>
          ))}
        </Grid>
      </Container>
    </div>
  )
}

MagazineIssueHighlights.propTypes = {
  highlights: arrayOf(
    shape({
      title: string,
      pageNumber: string,
      imageUrl: string,
      images: shape({
        main_141x106_141: arrayOf(
          shape({
            url: string
          })
        )
      })
    })
  ),
  onClick: func
}

export default MagazineIssueHighlights
